import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
// import moment from "moment";

import templateContent from "./contact-details-modal.html";

import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { folderManager } from "../../_shark_jaws/managers/folderManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class ContactDetailsModalComponent extends Component {
	constructor () {
		super("contactDetailsModalComponent");
		this.addTemplate("", templateContent);
	}

	contactDetailsModalSaveBtn_clickHandler () {
		const [currContact, currUser] = Shark.get(["currContact", "currUser"]);

		currContact.set({
			enabled: true,
			[`extraData.roles.${currContact.__sisType}`]: true,
			referenceAgentsGuids: [currUser.guid],
		});

		const isNewContact = currContact.guid === "";

		clientManager.save(currContact)
		.then(saveContactResponse => {
			console.log({saveContactResponse});

			//Dave: Questa roba dovrebbe stare sempre nel salvataggio del cliente...
			folderManager.getByReference(currContact.guid, "client")
			.then(getClientFolderResponse => {
				console.log({getClientFolderResponse});
				if (getClientFolderResponse.data.length === 0) {
					const clientFolder = Shark.getInstance("Folder", {
						clientGuid: currContact.guid,
						name: currContact.name,
						ownerGuid: currUser.guid,
						parentGuid: currUser.clientsFolderGuid,
						referenceGuid: currContact.guid,
						referenceType: "client",
						status: 1,
						type: "client",
					});
					
					folderManager.save(clientFolder);
				}
				else if (getClientFolderResponse.data.length === 1) {
					const clientFolder = getClientFolderResponse.data[0];
					
					if (clientFolder.name !== currContact.name) {
						clientFolder.set("name", currContact.name);
						folderManager.save(clientFolder);
					}
				}
				else {
					alert("Attenzione, si è verificato un errore. Per favore segnala il codice 'CDM-85'.");
				}
			});

			if (isNewContact) {
				// const referenceContactList = Shark.get(`${currContact.__sisType}List`);
				const [clientList, customerList, designerList, endUserList] = Shark.get(["clientList", "customerList", "designerList", "endUserList"]);
				clientList.push(currContact);
				customerList && customerList.push(currContact);
				designerList && designerList.push(currContact);
				endUserList && endUserList.push(currContact);
			}

			$("#contactDetailsModal").modal("hide");

			let currDocument = this.get("referenceDocument");
			currDocument.set(`registry.${currContact.__sisType}Guid`, currContact.guid);

			if (currDocument.registry.receiver === currContact.__sisType) {
				//Dave: QUesto serve anche per CSC e CS??
				currDocument.setContactAsReceiver(currContact, currContact.__sisType);
			}
			else {
				Shark.render();
			}
		});
	}

	editContactDetailsBtn_clickHandler (event, data) {
		if (!this.get("referenceDocument") || this.get("referenceDocument") === "") {
			alert("Attenzione, non è stato impostato il documento di riferimento");
			return;
		}

		let currDocument = this.get("referenceDocument");

		let currContact;
		let typeLabel = "";
		let property = "";

		switch (data.type) {
			case "customer":
				typeLabel = "Committente";
				property = "registry.customerGuid";
				break;
			case "designer":
				typeLabel = "Progettista";
				property = "registry.designerGuid";
				break;
			case "endUser":
				typeLabel = "Utilizzatore Finale";
				property = "registry.endUserGuid";
				break;
			case "invoiceReceiver":
				typeLabel = "Destinatario Fattura";
				property = "registry.invoiceReceiverGuid";
				break;
		}

		const propertyValue = Utils.getDeepProperty(currDocument, property);
		if (propertyValue !== "") {
			const clientList = Shark.get("clientList");
			currContact = Utils.safp(clientList, "guid", propertyValue);
		}

		if (!currContact) {
			currContact = Shark.getInstance("Client", {});
		}

		Shark.set({currContact});
		console.log({event, data, currContact});
		currContact.set({
			__sisType: data.type,
			__sisTypeLabel: typeLabel
		});
		this.open();
	}

	editContactDetails2Btn_clickHandler (event, data) {
		// if (!this.get("referenceDocument") || this.get("referenceDocument") === "") {
		// 	alert("Attenzione, non è stato impostato il documento di riferimento");
		// 	return;
		// }

		const contactGuid = data.contactGuid;
		
		if (contactGuid && contactGuid.trim() !== "") {
			waitBoxComponent.open();

			clientManager.getByGuid(contactGuid)
			.then(response => {
				const currContact = response.data;
				// switch (data.type) {
				// 	case "customer":
				// 		typeLabel = "Committente";
				// 		property = "registry.customerGuid";
				// 		break;
				// 	case "designer":
				// 		typeLabel = "Progettista";
				// 		property = "registry.designerGuid";
				// 		break;
				// 	case "endUser":
				// 		typeLabel = "Utilizzatore Finale";
				// 		property = "registry.endUserGuid";
				// 		break;
				// 	case "invoiceReceiver":
				// 		typeLabel = "Destinatario Fattura";
				// 		property = "registry.invoiceReceiverGuid";
				// 		break;
				// }
				
				// const propertyValue = Utils.getDeepProperty(currDocument, property);

				// if (propertyValue !== "") {
				// 	const clientList = Shark.get("clientList");
				// 	currContact = Utils.safp(clientList, "guid", propertyValue);
				// }

				// if (!currContact) {
				// 	currContact = Shark.getInstance("Client", {});
				// }
				
				Shark.set({currContact});
				console.log({event, data, currContact});
				waitBoxComponent.close();
				// currContact.set({
				// 	__sisType: data.type,
				// 	__sisTypeLabel: typeLabel
				// });
				this.open();
			});
		}
	}

	open () {
		Shark.render();
		$("#contactDetailsModal").modal("show");
	}

	showContactDetails (guid) {
		if (guid && guid.trim() !== "") {
			waitBoxComponent.open();

			clientManager.getByGuid(guid)
			.then(response => {
				// console.log({event, data, currContact});
				
				const currContact = response.data;
				waitBoxComponent.close();

				if (currContact) {
					Shark.set({currContact});
					this.open();
				}
				else {
					alert("Mi spiace, si è verificato un problema e non trovo il Contatto richiesto.");
				}
			});
		}
	}

	showContactDetailsBtn_clickHandler (event, data) {
		const contactGuid = data.guid;
		this.showContactDetails(contactGuid);
	}
}

const contactDetailsModalComponent = new ContactDetailsModalComponent();

Shark.registerComponent(contactDetailsModalComponent);

export default contactDetailsModalComponent;
